import React from 'react'
import { Pressable, Text, View } from 'react-native'
import { match } from 'ts-pattern'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import { body2, caption } from '@ui-kit/core/typography'

import * as styles from './styles'
import type { NativeProps } from './types'

const fillImages = {
  dot: IMAGE.icons.small.dot_24,
  checkmark: IMAGE.icons.xsmall.checkmarkWhite_14x11,
}

const SelectionButton = (props: NativeProps): JSX.Element => {
  const onPress = () => {
    if (props.disabled) {
      return
    }
    props.onPress(props.value)
  }

  const { container, textContainer, aid, aidContainer, radioDot } = styles.selectionButton({
    hasError: props.hasError,
    noOutline: props.noOutline,
    disabled: props.disabled,
    type: props.selectType,
    selected: props.isSelected,
  })

  const selectedComponent = match(props)
    .with({ isSelected: true, selectType: 'radio' }, () => {
      return <View className={radioDot()} />
    })
    .with({ isSelected: true, selectType: 'checkbox' }, () => {
      return <Icon imgSrc={fillImages.checkmark} />
    })
    .otherwise(() => null)

  return (
    <Pressable className={container()} style={props.style} onPress={onPress} testID={props.id}>
      {props.icon}
      <View className={textContainer()}>
        <Text className={body2({ align: 'left', emphasis: props.disabled ? 'low' : 'default' })}>
          {props.title}
        </Text>
        {props.subtitle && (
          <Text
            className={caption({
              align: 'left',
              emphasis: props.disabled ? 'low' : 'medium',
              color: props.hasError ? 'uiRed' : 'brandDark',
            })}
          >
            {props.subtitle}
          </Text>
        )}
      </View>
      <View className={aidContainer()}>
        <View className={aid()}>{selectedComponent}</View>
      </View>
    </Pressable>
  )
}

export default SelectionButton
